<!-- Zweck: Stellt die HTML-Struktur für shop view article details info component im Frontend bereit. -->
@if (!(article|async)) {
  <div>
    <div style="text-align: center; margin-top: 100px">
      <div style="display: inline-block">
        <mat-spinner></mat-spinner>
      </div>
      <div style="text-align: center">
        <h3>Lade...</h3>
      </div>
    </div>
  </div>
}

@if ((article|async) && (article_info|async)) {
  <div>
    <section-title [hasBack]="true" [label]="(article|async)?.ArtikelName" icon="vorschau">
      <article-dtp-icon labelSuffix [isDtp]="(article|async)?.IstDtpArtikel"></article-dtp-icon>
    </section-title>
    <div class="paddedcontent">
      <mat-toolbar>{{(article_info|async)?.label}}</mat-toolbar>
      <div class="paddedcontent articledetailsbox mat-elevation-z1">
        @if ((article_info|async)?.text) {
          <div [innerHTML]="(article_info|async)?.text|nl2br|raw">
          </div>
        }
        @if ((article_info|async)?.file && !show_pdf_viewer) {
          <div style="padding: 20px; text-align: center">
            <button (click)="download()" mat-flat-button>
              <svg-icon>downloads</svg-icon>
              @if ((article_info|async)?.file.mimetype == 'application/pdf') {
                <span>
                  Anzeigen
                </span>
              }
              @if ((article_info|async)?.file.mimetype != 'application/pdf') {
                <span>
                  Herunterladen
                </span>
              }
            </button>
          </div>
        }
        @if (show_pdf_viewer) {
          <div #pdfviewerdiv class="pdfviewerdiv">
            <ng2-pdfjs-viewer #pdfViewer
              [openFile]="false"
              style="height: 100%;"
            ></ng2-pdfjs-viewer>
          </div>
        }
      </div>
    </div>
  </div>
}
